import React from 'react'
import Logo from '../Img/logo.png'
import Axios from 'axios'
import {handleLogout} from "../Utils/auth";
import MasterTemplate from "./MasterTemplate";
import { Link } from 'react-router-dom';

export class Configuracoes extends React.Component {
    constructor(props) {
        super(props)
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        this.state = {
            user: JSON.parse(localStorage.getItem('user')),
        }
    }

    getUser = async e => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("usuarios/user", {
                id: this.state.user._id
            });

            window.localStorage.setItem('user', JSON.stringify(response.data[0]))
            this.setState({user: response.data[0]})
        } catch (err) {
            console.log(err)
        }
    }

    render() {
        return (
            <MasterTemplate label="Perfil">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Perfil</h4>
                                </div>
                                <div className="card-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-5 pr-1">
                                                <div className="form-group">
                                                    <label>Perfil</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled={true}
                                                        placeholder="Perfil"
                                                        value={this.state.user.perfil}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 px-1">
                                                <div className="form-group">
                                                    <label>Nome</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled
                                                        placeholder="Nome"
                                                        value={this.state.user.nome}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 pl-1">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Email</label>
                                                    <input
                                                        type="email"
                                                        disabled
                                                        className="form-control"
                                                        placeholder="Email"
                                                        value={this.state.user.email}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 pr-1">
                                                <div className="form-group">
                                                    <label>CPF</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled
                                                        placeholder="CPF"
                                                        value={this.state.user.cpf}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 pl-1">
                                                <div className="form-group">
                                                    <label>Comissão</label>
                                                    <input
                                                        type="text"
                                                        disabled
                                                        className="form-control"
                                                        placeholder="Comissão"
                                                        value={this.state.user.comissao}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Endereço</label>
                                                    <input
                                                        type="text"
                                                        disabled
                                                        className="form-control"
                                                        placeholder="Endereço"
                                                        value={this.state.user.endereco}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 pr-1">
                                                <div className="form-group">
                                                    <label>Cidade</label>
                                                    <input
                                                        disabled
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="City"
                                                        value={this.state.user.cidade}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 px-1">
                                                <div className="form-group">
                                                    <label>Bairro</label>
                                                    <input
                                                        disabled
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Bairro"
                                                        value={this.state.user.bairro}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 pl-1">
                                                <div className="form-group">
                                                    <label>Status</label>
                                                    <input
                                                        disabled
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Status"
                                                        value={
                                                            this.state.user.status
                                                                ? 'Ativo'
                                                                : 'Bloqueado'
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="clearfix"/>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        )
    }
}

export default Configuracoes
